import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-no-record-container',
    templateUrl: './no-record-container.component.html',
    styleUrls: ['./no-record-container.component.scss'],
    imports: [TranslateModule]
})
export class NoRecordContainerComponent implements OnInit {
  @Input()
  message: string = 'message.not_record_found';

  constructor() { }

  ngOnInit(): void {
  }

}
